import React from 'react';

interface DialogManagerContextProps {
    pushDialog: (dialog: React.ReactElement) => void;
}
const DialogManagerContext = React.createContext<DialogManagerContextProps | undefined>(undefined);

function useDialogManagerContext() {
    const context = React.useContext(DialogManagerContext);

    if (!context) {
        throw new Error('useContext must be used within a DialogContextProvider');
    }

    return context;
}

/**
 * @deprecated
 */
function DialogManagerProvider({ children }: React.PropsWithChildren<{}>) {
    const idRef = React.useRef<number>(1);
    const [dialogs, setDialogs] = React.useState<React.ReactElement[]>([]);

    function hideDialog(id: number) {
        setDialogs(dialogs.filter(d => d.props.__id !== id));
    }

    function pushDialog(dialog: React.ReactElement) {
        const newId = idRef.current++;
        setDialogs([
            ...dialogs,
            React.cloneElement(dialog, {
                onHide: () => hideDialog(newId),
                __id: newId,
            }),
        ]);
    }

    return (
        <DialogManagerContext.Provider value={{ pushDialog }}>
            {children}
            {dialogs.map(dialog => dialog)}
        </DialogManagerContext.Provider>
    );
}

export { useDialogManagerContext, DialogManagerProvider };
